import { ueApi } from '../api'

/**
 * Email Universe data layer
 * 
 * Provides methods to read and manipulate email universe
 * Depends on an API module that provides HTTP methods
 * 
 * @param {object} api - API module to interact with the server
 * @param object.get - GET method
 * @param object.post - POST method
 */
const UEmailAPI = () => {
    return {
        addFile,
        getCurrentStatus,
        fullBuild
    }

    /**
     * Add/update a file to source
     */
    async function addFile(input) {
        const url = "/api/uemail/add-file"

        const {
            source,
            generator,
            category,
            contact_scraping_method,
            linkedin_approach,
            date,
            input_file,
            cookie_file,
            csrf_token,
            parameters,
        } = input


        const data = new FormData()

        data.append("source", source)
        data.append("generator", generator)
        data.append("category", category)
        data.append("contact_scraping_method", contact_scraping_method)
        data.append("linkedin_approach", linkedin_approach)
        data.append("date", date)

        if (input_file) {
            data.append("input_file", input_file.originFileObj)
        }

        if (cookie_file) {
            data.append("cookie_file", cookie_file.originFileObj)
        }

        if (csrf_token) {
            data.append("csrf_token", `ajax:${csrf_token}`)
        }

        if (parameters) {
            data.append("params", JSON.stringify(parameters))
        }


        return await ueApi.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }

    /**
     * Get current build status
     */
    async function getCurrentStatus() {
        const status = await ueApi.get(`/api/uemail/current-status`)

        return status
    }

    /**
     * Perform full build
     */
    async function fullBuild() {
        const status = await ueApi.get(`/api/uemail/full-build`)

        return status
    }
}

export default UEmailAPI